// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header.MuiAppBar-root.header-container{min-height:5rem;height:5rem}`, "",{"version":3,"sources":["webpack://./src/components/Header.scss"],"names":[],"mappings":"AAAA,uCACE,eAAA,CACA,WAAA","sourcesContent":["header.MuiAppBar-root.header-container {\n  min-height: 5rem;\n  height: 5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
